'use client'

import { useTranslation } from '@shared/config/i18n'

import { BottomSheetContent, BottomSheetHeader, Typography, VStack } from '@podo-app/design-system-temp'

type Props = {
  onChatConsultation: () => void
  onLineLoginWithAccountSelection: () => void
}

const LineLoginOptionsBottomSheet = ({ onChatConsultation, onLineLoginWithAccountSelection }: Props) => {
  const t = useTranslation()

  return (
    <BottomSheetContent size="hug">
      <VStack className="h-full justify-between">
        <BottomSheetHeader className="flex flex-col">
          <VStack className="w-full gap-0">
            <button type="button" className="w-full py-5" onClick={onChatConsultation}>
              <Typography size="h3">{t('common.auth.chatConsultation')}</Typography>
            </button>
            <button type="button" className="w-full py-5" onClick={onLineLoginWithAccountSelection}>
              <Typography size="h3">{t('common.auth.otherLineLogin')}</Typography>
            </button>
          </VStack>
        </BottomSheetHeader>
      </VStack>
    </BottomSheetContent>
  )
}

export default LineLoginOptionsBottomSheet
